<template><div class="app-container"><router-view /></div></template><script setup lang="ts">import { useRouter } from 'vue-router'

const router = useRouter()

// 检查用户登录状态
const token = localStorage.getItem('token')
if (!token && router.currentRoute.value.path !== '/login') {
  router.push('/login')
}</script><style>/* 全局样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f5f7fa;
}

#app {
  width: 100%;
  min-height: 100vh;
}</style>